import { useContext, useState } from "react";
import { appBaseUrl, appDownloadUrl } from "@base-url";
import { WhatsappShareButton, WhatsappIcon, FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from "react-share";
import blogClasses from "../styles/singleBlogView.module.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast, ToastContainer } from "react-toastify";
import { injectStyle } from "react-toastify/dist/inject-style";
import { Store } from "@store";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { trackEvent } from "@utils/analytics/event-analytics";
import { LANGUAGE, WEB_ENGAGE } from "@utils/constants";
import BlogRelatedEventCard from "./blogRelatedEventCard";
if (typeof window !== "undefined") {
  injectStyle();
}
function BlogShareOptions({
  blogID,
  headline,
  urlExtension,
  relatedEvents = []
}) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  let postURL = "";
  if (router.locale === LANGUAGE.ENGLISH) {
    postURL = appBaseUrl + "/blogs/" + urlExtension;
  } else {
    postURL = appBaseUrl + `/${router.locale}` + "/blogs/" + urlExtension;
  }
  const shareText = `*Check out this blog on Utsav* \n\nBlog Link: \n${postURL} \n\nDownload Utsav App👇`;
  const [value, setValue] = useState(postURL);
  let download_url;
  if (loggedInUser.referralID) {
    download_url = `https://utsavapp.in/download?referrer=${loggedInUser.referralID}`;
  } else {
    download_url = "https://utsavapp.in/download";
  }
  return <div className={blogClasses.shareRoot} data-sentry-component="BlogShareOptions" data-sentry-source-file="BlogShareOptions.jsx">
      <div className={blogClasses.shareText}>
        <span>Share</span>
      </div>
      <div className={blogClasses.blogShareContainer}>
        <div className={blogClasses.whatsapp_share_btn_container}>
          <WhatsappShareButton url={download_url} separator={"\n"} title={shareText} className={blogClasses.whatsapp_share_btn} onClick={() => {
          trackEvent(WEB_ENGAGE.EVENT_NAMES.BLOG_SHARED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_SCREEN,
            [WEB_ENGAGE.EVENT_PROPERTIES.BLOG_NAME]: headline,
            [WEB_ENGAGE.EVENT_PROPERTIES.SHARE_MEDIUM]: WEB_ENGAGE.SHARE_MEDIUM.WHATSAPP
          });
        }} data-sentry-element="WhatsappShareButton" data-sentry-source-file="BlogShareOptions.jsx">
            {/* <span className={blogClasses.share_btn_text}>Share</span> */}
            <WhatsappIcon size={36} className={blogClasses.shareOptionIconMargin} round="true"
          // iconFillColor="white"
          data-sentry-element="WhatsappIcon" data-sentry-source-file="BlogShareOptions.jsx" />
          </WhatsappShareButton>
        </div>
        <div className={blogClasses.whatsapp_share_btn_container}>
          <FacebookShareButton url={appDownloadUrl} separator={"\n"} title={shareText} className={blogClasses.whatsapp_share_btn} onClick={() => {
          trackEvent(WEB_ENGAGE.EVENT_NAMES.BLOG_SHARED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_SCREEN,
            [WEB_ENGAGE.EVENT_PROPERTIES.BLOG_NAME]: headline,
            [WEB_ENGAGE.EVENT_PROPERTIES.SHARE_MEDIUM]: WEB_ENGAGE.SHARE_MEDIUM.FACEBOOK
          });
        }} data-sentry-element="FacebookShareButton" data-sentry-source-file="BlogShareOptions.jsx">
            <FacebookIcon size={36} round="true" className={blogClasses.shareOptionIconMargin} data-sentry-element="FacebookIcon" data-sentry-source-file="BlogShareOptions.jsx" />
          </FacebookShareButton>
        </div>
        <div className={blogClasses.whatsapp_share_btn_container}>
          <TwitterShareButton url={appDownloadUrl} separator={"\n"} title={shareText} className={blogClasses.whatsapp_share_btn} onClick={() => {
          trackEvent(WEB_ENGAGE.EVENT_NAMES.BLOG_SHARED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_SCREEN,
            [WEB_ENGAGE.EVENT_PROPERTIES.BLOG_NAME]: headline,
            [WEB_ENGAGE.EVENT_PROPERTIES.SHARE_MEDIUM]: WEB_ENGAGE.SHARE_MEDIUM.TWITTER
          });
        }} data-sentry-element="TwitterShareButton" data-sentry-source-file="BlogShareOptions.jsx">
            <TwitterIcon size={36} round="true" className={blogClasses.shareOptionIconMargin} data-sentry-element="TwitterIcon" data-sentry-source-file="BlogShareOptions.jsx" />
          </TwitterShareButton>
        </div>
        <div className={`${blogClasses.whatsapp_share_btn_container}`}>
          <CopyToClipboard text={value} onCopy={() => {
          toast.success(`${t("copied-successfully")}`, {
            autoClose: 2000
          });
          trackEvent(WEB_ENGAGE.EVENT_NAMES.BLOG_SHARED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_SCREEN,
            [WEB_ENGAGE.EVENT_PROPERTIES.BLOG_NAME]: headline,
            [WEB_ENGAGE.EVENT_PROPERTIES.SHARE_MEDIUM]: WEB_ENGAGE.SHARE_MEDIUM.GENERAL
          });
        }} data-sentry-element="CopyToClipboard" data-sentry-source-file="BlogShareOptions.jsx">
            <ContentCopyIcon className={blogClasses.blogShareOptionCopy} round="true"
          // onClick={notify}
          // id="animate.css"
          // iconFillColor="white"
          data-sentry-element="ContentCopyIcon" data-sentry-source-file="BlogShareOptions.jsx" />
          </CopyToClipboard>
        </div>
      </div>
      {relatedEvents.length > 0 && <BlogRelatedEventCard data={relatedEvents} />}
      <ToastContainer data-sentry-element="ToastContainer" data-sentry-source-file="BlogShareOptions.jsx" />
    </div>;
}
export default BlogShareOptions;